<template>
  <div class="valign-wrapper">
    <div class="card center">
      <div class="loginForm">
        <h3>Sign-In</h3>
        <input class="signInField" type="email" v-model="email" placeholder="Enter email">
        <input class="signInField" type="password" v-model="password" placeholder="Enter password">
      </div>
      <button class="signInButton btn-large" @click.prevent="signInWithEmail">Sign-in</button>
      <!-- FirebaseUI sign-in buttons -->
      <div id="firebaseui-auth-container" class="mt-8"></div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'

export default {
  name: 'Login',
  data() {
    return {
      email: null,
      password: null,
      feedback: null
    }
  },
  mounted() {
    const uiConfig = {
      callbacks: {
        //Setting the user in the store off a successful login
        //Navigate to the Dashboard view
        signInSuccessWithAuthResult: authResult => {
          this.$store.dispatch('setUser', authResult.user)
          this.$router.push({ name: 'Dashboard' })
          return false
        }
      },
      signInOptions: [
        //Adds options for Email & Google Login
        
        this.$firebase.auth.GoogleAuthProvider.PROVIDER_ID
      ]
    }
    this.$firebaseui.start('#firebaseui-auth-container', uiConfig)
  },
  methods: {
    signInWithEmail() {
      if(this.email && this.password) {
        firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          .then(cred => {
          console.log(cred.user)
          this.$router.push('/')
      }).catch(err => {
        this.feedback = null
        console.log(err)
      })
      } else {
        this.feedback = 'Please fill in both fields'
      }
    }
  }
}
</script>

<style scoped>
h3 {
  margin-bottom: 30px;
}
.signInField{
  margin: 20px 0px !important;
}
.valign-wrapper {
  height: 70vh;
}
.card {
  border-radius: 10px;
  height: auto;
  padding: 40px;
  margin: auto;
}
.loginForm {
  padding: 0px 40px;
}
.signInButton {
  background-color: #19A3BF;
  /* background-color: #D55571; */
  width: 220px;
  text-transform: none;
  border-radius: 3px;
  font-size: 1.2em;
  margin: 30px 0px 0px 0px;
}
#firebaseui-auth-container{
  padding-top: 20px;
}
</style>
